import debounce from 'lodash.debounce';

export default {

    inserted: function (el, binding) {

        let data = {
            scrollDirection: false,
            scrollPosition: 0
        };

        window.addEventListener('scroll', debounce(() => {

            if (getComputedStyle(el).display !== 'none' && !window.isViewport(binding.value.breakpoint)) {
                let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
                if (scrollTop !== data.scrollPosition) {
                    data.scrollDirection = scrollTop > data.scrollPosition ? 'down' : 'up';
                    data.scrollPosition = scrollTop;

                    window.requestAnimationFrame(() => {
                        if (binding.value.direction == data.scrollDirection) {
                            el.classList.add('is-hidden');
                        } else {
                            el.classList.remove('is-hidden');
                        }
                    });
                }
            } else if(el.classList.contains('is-hidden')) {
				el.classList.remove('is-hidden');
			}

        }), 700);

	}

}
